export default {
  labels: {
    invoice: 'Factură',
    on_site: 'Plată la fața locului (Numerar/Card)',
  },
};
